<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg4 md4 sm12>
            <v-text-field
              :disabled="currentCustomer.ID > 0"
              label="Tài khoản"
              v-model="currentCustomer.Email"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-text-field
              :disabled="!roleEditable"
              label="Họ Tên"
              v-model="currentCustomer.FullName"
              @input="onNamePhoneChanged"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 sm12>
              <v-text-field
                :disabled="!roleEditable"
                label="Điện thoại"
                v-model="currentCustomer.PhoneNumber"
                @input="onNamePhoneChanged"
                class="input-group--focused"
                :rules="requireRules"
              ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select v-model="currentCustomer.LevelID" :items="customerLevels" item-text="VIPName" item-value="VipValue" label="Hạng thành viên"></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input disabled v-model="currentCustomer.Point" :decimal="0" label="Doanh số" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Trạng thái"
              :items="customerStatus"
              v-model="currentCustomer.Status"
              item-text="name"
              item-value="value"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-autocomplete :disabled="!roleEditable" v-model="currentCustomer.SaleID" :items="sale_staffs" item-text="FullName" item-value="ID" label="Nhân viên sale" clearable></v-autocomplete>
          </v-flex>
          <v-flex lg8 md8 sm12>
            <v-text-field
              :disabled="!roleEditable"
              label="Địa chỉ"
              v-model="currentCustomer.Address"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-text-field
              label="Webhook Order"
              v-model="currentCustomer.EndpointCRM"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-switch
              v-model="currentCustomer.ApproveDebt"
              label="Duyệt công nợ"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <label class="h4 font-weight-bold">Cài đặt phí đặc biệt</label>
          </v-flex>
          <v-flex lg12 md12 sm12 pa-0 pl-4>
            <v-btn small @click="addSpecialFee"><v-icon color="#055160">add</v-icon>Thêm mới</v-btn>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-data-table :headers="headers" :items="specialFees" :options.sync="pagination" :server-items-length="specialFees ? specialFees.length : 0" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>
                    <v-edit-dialog :return-value.sync="item.ShippingMethod" large lazy persistent @save="saveSpecialFee(item)">
                      <div v-bind:style="{ 'color': text_color(item.ShippingMethod, shipping_methods)}">{{ item.ShippingMethod | display_value(shipping_methods) }}</div>
                      <template v-slot:input>
                        <v-select v-model="item.ShippingMethod" :items="shipping_methods" item-text="name" item-value="value" label="Hình thức vận chuyển"></v-select>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>
                    <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent @save="saveSpecialFee(item)">
                      <div v-bind:style="{ 'color': text_color(item.ProductType, product_types)}">{{ item.ProductType | display_value(product_types) }}</div>
                      <template v-slot:input>
                        <v-select v-model="item.ProductType" :items="product_types" item-text="name" item-value="value" label="Loại hàng"></v-select>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>
                    <v-edit-dialog :return-value.sync="item.CalcType" large lazy persistent @save="saveSpecialFee(item)">
                      <div v-bind:style="{ 'color': text_color(item.CalcType, fee_types)}">{{ item.CalcType | display_value(fee_types) }}</div>
                      <template v-slot:input>
                        <v-select v-model="item.CalcType" :items="fee_types" item-text="name" item-value="value" label="Loại phí"></v-select>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.Amount" large lazy persistent @save="saveSpecialFee(item)">
                      <div>{{ item.Amount | currency }}</div>
                      <template v-slot:input>
                        <v-text-field type="number" step="1" v-model="item.Amount" label="Cước phí"></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-center">
                    <v-icon medium @click="deleteSpecialFee(index)">delete</v-icon>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <span>
                  <p class="pt-2">Chưa cài đặt phí đặc biệt</p>
                </span>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <label class="h4 font-weight-bold">Danh sách kiện hàng</label>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-data-table :headers="pk_header" :items="pk_items" :options.sync="pagination" :server-items-length="pk_rows" :footer-props="items_per_page" :must-sort="true" :loading="pk_loading" :mobile-breakpoint="100">
              <template v-slot:item="{ item }">
                <tr :id="'r-'+item.ID">
                  <td>{{ item.TransactionCode }}</td>
                  <td>{{ item.PackageCode }}</td>
                  <td>{{ item.Weight }}</td>
                  <td>{{ item.Length ? item.Length + ' x ' + item.Width + ' x ' + item.Height : '' }}</td>
                  <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                  <td>
                    <div>{{ item.FeeShipVND | currency('₫', 0)}}</div>
                    <div class="text-red">{{ item.FeeShip | currency('¥', 1)}}</div>
                  </td>
                  <td>{{ item.FeeOther | currency('') }}</td>
                  <td>{{ item.FeeShipCNVN | currency('') }}</td>
                  <td v-bind:style="{ 'color': text_color(item.ShippingMethod, shipping_methods)}">{{ item.ShippingMethod | display_value(shipping_methods) }}</td>
                  <td v-bind:style="{ 'color': text_color(item.ProductType, product_types)}">{{ item.ProductType | display_value(product_types) }}</td>
                  <td>{{ item.CreatedDate | display_date }}</td>
                  <td v-bind:style="{ 'color': text_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import {trade_type} from "@/commons/hpod";
import _ from "lodash";
export default {
  filters: {
    trade_type
  },
  data() {
    return {
      valid: true,
      pwdWarning: "Mật khẩu không khớp.",
      password: "",
      rePassword: "",
      customerStatus: configs.CUSTOMER_STATUS_LIST,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      shipping_methods: configs.SHIPPING_METHOD,
      product_types: configs.PRODUCT_TYPE,
      fee_types: configs.FEE_TYPES,
      package_status: configs.PACKAGE_STATUS,
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      headers: [
        {
          text: "Hình thức vận chuyển",
          value: "ShippingMethod",
          filterable: true,
          values: configs.SHIPPING_METHOD,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Loại hàng",
          value: "ProductType",
          filterable: true,
          values: configs.PRODUCT_TYPE,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Loại phí",
          value: "CalcType",
          filterable: true,
          values: configs.FEE_TYPES,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Cước phí",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "",
          value: "",
        }
      ],
      pk_header: [
        {
          text: "Mã kiện",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã lô hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Kích thước",
          value: "Volume",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số khối",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship nội địa",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí phát sinh",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship TQ-VN",
          value: "FeeShipCNVN",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Hình thức vận chuyển",
          value: "ShippingMethod",
          filterable: true,
          values: configs.SHIPPING_METHOD,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Loại hàng",
          value: "ProductType",
          filterable: true,
          values: configs.PRODUCT_TYPE,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: configs.DATA_TYPE["Enum"]
        }
      ]
    };
  },
  computed: {
    ...mapState("customer", {
      loading: "loading",
      currentCustomer: "selected"
    }),
    ...mapState({
      customerLevels: state => state.customerLevel.all.data,
      specialFees: state => state.specialFee.all.data,
      loading: state => state.specialFee.loading,
      pk_items: state => state.storeManager.all.data,
      pk_rows: state => state.storeManager.all.total,
      pk_loading: state => state.storeManager.loading,
      sale_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return o.RoleID  === configs.ROLE_TYPE.Sale || o.RoleID  === configs.ROLE_TYPE.Staff || o.RoleID  === configs.ROLE_TYPE.Ctv;
        }),
    }),
    customerId() {
      return this.$route.params.Pid;
    },
    passwordConfirmationRule() {
      return this.password === this.rePassword || this.pwdWarning;
    },
    locationStore() {
        return configs.LOCATION_STORE;
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    }
  },
  watch: {
    roleEditable() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable});
    }
  },
  methods: {
    text_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    generateCode() {
      var acronym = this.currentCustomer.FullName ? this.currentCustomer.FullName.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'') : '';
      var phone = this.currentCustomer.PhoneNumber;
      phone = phone ? phone.substring(phone.length - 4, phone.length) : '';
      return (acronym + phone).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    onNamePhoneChanged() {
      this.currentCustomer.Username = this.generateCode();
    },
    getListFee() {
        var param = {
          pagination: this.pagination,
          filter: [{
            column: "UID",
            value: this.customerId,
            condition: "s_equal"
          }],
          quickFilter: []
        };
        this.$store.dispatch("specialFee/getList", param);
    },
    getListPackage() {
      var param = {
        pagination: this.pagination,
        filter: [{
          column: "UID",
          value: this.customerId,
          condition: "s_equal"
        }],
        quickFilter: []
      };
      this.$store.dispatch("storeManager/getList", param);
    },
    refreshData() {
      this.$store.dispatch("customerLevel/getCustomerLevelList", {});
      if (this.customerId > 0) {
        this.$store.dispatch("customer/getCustomerDetail", this.customerId);
        this.getListFee();
        this.getListPackage();
      }
      else {
        this.$store.commit("customer/setCustomerDetail", {
        'data': {
            ID: 0,
            RoleID: 0,
            Status: 1,
            Username: '',
            FullName: '',
            PhoneNumber: '',
            is_active: 1,
            is_admin: 0
        }
        });
      }
    },
    resetPassword() {
      this.currentCustomer.Password = '123@456';
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
        resetPwd: true
      });
    },
    saveData() {
      let level = _.find(this.customerLevels, {
        VipValue: this.currentCustomer.LevelID
      });
      this.currentCustomer.LevelName = level ? level.VIPName : '';
      if(!this.currentCustomer.ID) {
        this.currentCustomer.Password = '123@456';
      }
      this.currentCustomer.SaleID = this.currentCustomer.SaleID || 0;
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId
      });
    },
    addSpecialFee() {
      this.specialFees.push({
          ID: 0,
          UID: this.customerId,
          ShippingMethod: configs.SHIPPING_METHOD_ENUM.TMDT,
          ProductType: configs.PRODUCT_TYPE_ENUM.All,
          CalcType: configs.FEE_TYPE.ByWeight,
          Amount: 0
      })
    },
    saveSpecialFee(item) {
      this.$store.dispatch("specialFee/setDetail", {
        data: {
          ...item,
          UID: this.customerId
        },
        id: item.ID,
        params: {
          pagination: this.pagination,
          filter: [{
            column: "UID",
            value: this.customerId,
            condition: "s_equal"
          }],
          quickFilter: []
        }
      });
    },
    deleteSpecialFee(index) {
      const item = this.specialFees[index];
      if (index > -1) {
        this.specialFees.splice(index, 1);
      }
      if(item.ID > 0) {
        this.$store.dispatch("specialFee/removeDetail", item.ID);
      }
    },
  },
  mounted() {
    this.refreshData();
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable});
    this.$store.dispatch("commons/getAllUsers");
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.resetPassword);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.resetPassword);
  }
};
</script>

<style>
</style>
